import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/layout/home/home.component';
import { MainComponent } from './views/layout/main/main.component';
import { authGuard } from './auth/auth.guard';

import { UnauthorizedComponent } from './views/layout/unauthorized/unauthorized.component';


import { AIAssistComponent } from './views/layout/aiassist/aiassist.component';

import { SettingsComponent } from './views/layout/settings/settings.component';
import { PageNotFoundComponent } from './views/layout/page-not-found/page-not-found.component';
import { DashboardComponent } from './views/layout/dashboard/dashboard.component';


const routes: Routes = [
  { path: 'login', component: HomeComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'main', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
  },
  {
    path: 'main',
    component: MainComponent,

    canActivate: [authGuard],
    children: [
      { path: 'settings', component: SettingsComponent },

      {
        path: 'rfpcontracts',
        loadChildren: () =>
          import('../app/views/layout/rfpcontract/rfpcontract.module').then(
            (m) => m.RfpcontractModule,
          ),
      },
      { path: 'aiassist', component: AIAssistComponent },

      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
      },
    ],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
